module.exports = __webpack_public_path__ + "img/contact-request-sent-thank-you-en.e216f55.png";